import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

type State = {
  autosave: boolean
}

const initialState: State = {
  autosave: true,
}

const slice = createSlice({
  name: "prefs",
  initialState,
  reducers: {
    setAutosave(state, { payload }: PayloadAction<boolean>) {
      state.autosave = payload
    },
  },
  selectors: {
    getAutosave: (state) => state.autosave,
  },
})

export const { setAutosave } = slice.actions
export const { getAutosave } = slice.selectors

export default slice
